import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable */
import React, { useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import { ConfigActions, JourneysSelectors, useAppDispatch, useAppSelector, } from 'conversional-journey';
import { createComponentsFromObject } from 'conversional-components';
import { sendToHost } from 'conversional-iframe-communication';
var Arbitrary = function (_a) {
    var content = _a.content, onApplyStyles = _a.onApplyStyles, iframeStyles = _a.iframeStyles, bodyStyles = _a.bodyStyles, externalData = _a.externalData;
    var theme = useAppSelector(JourneysSelectors.selectTheme);
    var dispatch = useAppDispatch();
    useEffect(function () {
        sendToHost.styleIframe(iframeStyles, !isEmpty(iframeStyles));
        bodyStyles && sendToHost.styleParentBody(bodyStyles);
        dispatch(ConfigActions.setExternal({ data: externalData }));
        onApplyStyles();
    }, []);
    return (_jsx(_Fragment, { children: content &&
            createComponentsFromObject({
                root: content || {},
            }) }));
};
export default Arbitrary;
